export const TIMEZONES = [
  { value: 'America/Denver', label: 'America/Denver' },
  { value: 'America/Chicago', label: 'America/Chicago' },
  { value: 'America/New_York', label: 'America/New York' },
  { value: 'America/Los_Angeles', label: 'America/Los Angeles' },
  { value: 'Pacific/Honolulu', label: 'Pacific/Honolulu' },
  { value: 'America/Phoenix', label: 'America/Phoenix' },
  { value: 'Europe/London', label: 'Europe/London' },
  { value: 'Europe/Zurich', label: 'Europe/Zurich' },
  { value: 'America/Indiana/Indianapolis', label: 'America/Indiana/Indianapolis' },
  { value: 'Australia/Sydney', label: 'Australia/Sydney' },
  { value: 'America/Detroit', label: 'America/Detroit' },
  { value: 'America/Vancouver', label: 'America/Vancouver' },
  { value: 'America/Anchorage', label: 'America/Anchorage' },
  { value: 'America/Boise', label: 'America/Boise' },
  { value: 'America/Edmonton', label: 'America/Edmonton' },
  { value: 'America/Santo_Domingo', label: 'America/Santo Domingo' },
  { value: 'America/Grand_Turk', label: 'America/Grand Turk' },
  { value: 'America/Curacao', label: 'America/Curacao' },
  { value: 'America/Toronto', label: 'America/Toronto' },
  { value: 'America/St_Johns', label: 'America/St Johns' },
  { value: 'America/Halifax', label: 'America/Halifax' },
];

export const DEFAULT_TEMPLATE_BUTTONS = [
  { value: ':name:', label: 'Client Name' },
  { value: ':review_link:', label: 'Review Link' },
  { value: ':store:', label: 'Store Name' },
  { value: ':associate:', label: 'Associate Name' },
];

export const MASS_MESSAGE_TEMPLATE_BUTTONS = [
  { value: ':name:', label: 'Client Name' },
  { value: ':review_link:', label: 'Review Link' },
  { value: ':store:', label: 'Store Name' },
  { value: ':associate:', label: 'Associate Name' },
];

export const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const LARGE_AUDIENCE_THRESHOLD = 5000;
